import { createNavigation } from 'next-intl/navigation'
import { defaultLocale, localePrefix, locales } from './locale'

// Use a lightweight navigation config so links accept any app route,
// while still honoring the "as-needed" locale prefix behavior.
export const { Link, redirect, usePathname, useRouter } = createNavigation({
  locales,
  defaultLocale,
  localePrefix,
})
